import React from "react";

function Home() {
  return (
    <div className="container text-center page-header">
      <h3 className="mb-5">Hello there! Welcome to my bookstore!</h3>

      <p className="mt-5">
        Kindly navigate using the links at the top right corner.
      </p>
    </div>
  );
}
export default Home;
